import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const UrbanArea = {
  id: PropTypes.number,
  name: PropTypes.string,
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const UrbanAreaShape = PropTypes.shape(UrbanArea);
export const UrbanAreaExact = PropTypes.exact(UrbanArea);
